import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Trophy, Mic, Eye } from 'lucide-react';
import { toast } from 'sonner';
import { joinSession } from './liveApi';
import Lobby from './Lobby';

// Page publique « Rejoindre » façon Kahoot : PIN + pseudo, sans compte.
const JoinPage = () => {
  const [pin, setPin] = useState('');
  const [nickname, setNickname] = useState('');
  const [role, setRole] = useState('audience');
  const [loading, setLoading] = useState(false);
  const [joinInfo, setJoinInfo] = useState(null);

  if (joinInfo) {
    return <Lobby joinInfo={joinInfo} />;
  }

  const handleJoin = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await joinSession(pin.trim(), nickname.trim(), role);
      setJoinInfo(response.data);
    } catch (error) {
      const status = error.response?.status;
      const messages = {
        404: 'Aucune session avec ce code. Vérifiez le PIN.',
        409: error.response?.data?.detail === 'Session has already started'
          ? 'Cette session a déjà commencé.'
          : 'Ce pseudo est déjà pris dans cette session.',
        401: 'Cette session demande de se connecter avant de rejoindre.',
      };
      toast.error(messages[status] || 'Impossible de rejoindre la session.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-purple-700 flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-2">
            <Trophy className="h-12 w-12 text-indigo-600" />
          </div>
          <CardTitle className="text-3xl">Rejoindre un battle</CardTitle>
          <CardDescription>Entrez le code affiché à l'écran</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleJoin} className="space-y-4">
            <div>
              <Label htmlFor="pin">Code PIN</Label>
              <Input
                id="pin"
                inputMode="numeric"
                autoComplete="off"
                maxLength={6}
                placeholder="123 456"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                className="text-center text-3xl tracking-[0.4em] font-bold h-14"
                required
              />
            </div>
            <div>
              <Label htmlFor="nickname">Votre pseudo</Label>
              <Input
                id="nickname"
                maxLength={30}
                placeholder="ex. Sacha"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                required
              />
            </div>
            <div>
              <Label>Vous participez comment ?</Label>
              <div className="grid grid-cols-2 gap-2 mt-1">
                <Button
                  type="button"
                  variant={role === 'audience' ? 'default' : 'outline'}
                  onClick={() => setRole('audience')}
                >
                  <Eye className="w-4 h-4 mr-2" />
                  Public (je vote)
                </Button>
                <Button
                  type="button"
                  variant={role === 'storyteller' ? 'default' : 'outline'}
                  onClick={() => setRole('storyteller')}
                >
                  <Mic className="w-4 h-4 mr-2" />
                  Conteur
                </Button>
              </div>
            </div>
            <Button
              type="submit"
              className="w-full h-12 text-lg"
              disabled={loading || pin.length !== 6 || !nickname.trim()}
            >
              {loading ? 'Connexion…' : 'Rejoindre'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default JoinPage;
